import useAxios from 'axios-hooks';
import * as Const from '../../../utils/Const';
import React from 'react';
import { Auth } from 'aws-amplify';

export function useGetDashboardData(targetUrl: string, params: Record<string, string | number[]>) {
  const materialName = params[Const.KeyMaterialName];
  const sceneName = params[Const.KeySceneName];

  const [{ data, loading, error }, execute] = useAxios(
    {
      url: targetUrl,
      method: 'POST',
      data: params,
    },
    { manual: true }
  );

  const safeExecute = async () => {
    if (materialName === '' || sceneName === '') {
      console.log('Skipping request: materialName or sceneName is empty.');
      return Promise.resolve(); // 空のPromiseを返す
    }
    const headers = await getAuthHeader();

    return execute({ headers });
  };

  return { data, loading, error, execute: safeExecute };
}

export function useGetDropdownDataAuto(targetUrl: string, params: Record<string, string>) {
  // const [{ data, loading, error }] = useAxios({
  //   url: targetUrl,
  //   method: 'POST',
  //   data: params,
  // });

  // return { data, loading, error };
  const [{ data, loading, error }, execute] = useAxios(
    {
      url: targetUrl,
      method: 'POST',
      data: params,
    },
    { manual: true }
  );

  React.useEffect(() => {
    const fetch = async () => {
      const headers = await getAuthHeader();
      await execute({ headers });
    };
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetUrl, JSON.stringify(params)]);

  return { data, loading, error };
}

export function useGetDropdownData(targetUrl: string, params: Record<string, string>) {
  // const [{ data, loading, error }] = useAxios(
  //   {
  //     url: targetUrl,
  //     method: 'POST',
  //     data: params,
  //   }
  //   //    { useCache: false }
  // );
  const [{ data, loading, error }, execute] = useAxios(
    {
      url: targetUrl !== null ? targetUrl : '',
      method: 'POST',
      data: params,
    },
    { manual: true }
  );
  const safeExecute = async () => {
    if (targetUrl == null) {
      console.log('Skipping request: materialName or sceneName is empty.');
      return Promise.resolve(); // 空のPromiseを返す
    }
    const headers = await getAuthHeader();

    return execute({ headers });
  };

  return { data, loading, error, execute: safeExecute };
}

export function useProcessSettingsData(
  targetUrl: string,
  params: Record<string, string | number[]>
) {
  const orgID = params[Const.KeyOrgID];

  const [{ data, loading, error }, execute] = useAxios(
    {
      url: targetUrl,
      method: 'POST',
      data: params,
    },
    { manual: true }
  );

  const safeExecute = () => {
    if (!orgID) {
      console.log('Skipping request: orgID is empty.');
      return Promise.resolve(); // 空のPromiseを返す
    }
    return execute();
  };

  return { data, loading, error, execute: safeExecute };
}

export async function getAuthHeader() {
  const session = await Auth.currentSession();
  const accessToken = session.getAccessToken().getJwtToken();
  return {
    Authorization: `Bearer ${accessToken}`,
  };
}
